module.exports = __webpack_public_path__ + "img/content2.326a210b.png";